<template>
    <div>
        <multiselect v-model="template" :options="localizedTemplates" selectedLabel="ausgewählt"
                     selectLabel="Klicken zum Hinzufügen" deselectLabel="Klicken zum Entfernen"
                     placeholder="Vorlage auswählen" label="localizedTitle" @select="changeMessage" @remove="deleteMessage"
                     :close-on-select="true"
                     track-by="id"></multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {Multiselect},
        props: ['chatTemplates', 'customerLanguage'],
        data() {
            return {
                template: null,
            }
        },
        computed: {
            localizedTemplates() {
                const iso = this.customerLanguage || 'de';
                return this.chatTemplates.map(t => ({
                    ...t,
                    localizedTitle: t.translations?.title?.[iso] ?? t.title,
                    localizedText: t.translations?.text?.[iso] ?? t.text,
                }));
            }
        },
        methods: {
            changeMessage: function (selectedOption, id) {
                this.$emit('update-message', selectedOption.localizedText || selectedOption.text)
            },
            deleteMessage: function () {
                this.$emit('update-message', "")
            }
        },
    }
</script>

<style scoped lang="scss">
.multiselect--active {
  min-height: 200px;
}
.multiselect__content-wrapper {
  min-height: 200px;
}
</style>
